export const isTouchDevice = () => {
    const checkIfTouch: number | boolean =
        'ontouchstart' in window || navigator.maxTouchPoints
    return !!checkIfTouch
}
